/* 曹操傳・第 4 章：濮陽（194 年）
 * 濮陽城是方城，四面各一座城門；城裡民房密，巷道窄。曹操從東門進城。 */
export const CITY = { x: 3600, y: 2400, hw: 1300, hh: 900 };
const T = 36, G = 130, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATES = { n: [CITY.x, N], s: [CITY.x, S], w: [Wx, CITY.y], e: [E, CITY.y] };
const h = (y) => [[(Wx + CITY.x - G) / 2, y, (CITY.x - G - Wx) / 2 + T, T], [(CITY.x + G + E) / 2, y, (E - CITY.x - G) / 2 + T, T]];
const v = (x) => [[x, (N + CITY.y - G) / 2, T, (CITY.y - G - N) / 2], [x, (CITY.y + G + S) / 2, T, (S - CITY.y - G) / 2]];
export default {
  id: 'puyang', name: '濮陽', W: 7200, H: 4800, seed: 194,
  bases: [[6500, 2400], [3600, 2400]],
  walls: [...h(N), ...h(S), ...v(Wx), ...v(E)],
  roads: [
    { pts: [[6500, 2400], GATES.e, [CITY.x, CITY.y], GATES.w, [700, 2400]], w: 120 },
    { pts: [[CITY.x, 400], GATES.n, [CITY.x, CITY.y], GATES.s, [CITY.x, 4500]], w: 110 },
  ],
  rocks: [[1200, 1000, 360, 170], [6000, 1000, 360, 170], [1200, 3800, 360, 170], [6000, 3800, 360, 170]],
  woods: 0.4,
  sight: 0.6,
  clearings: [[CITY.x, CITY.y, 1500], [6500, 2400, 450], [700, 2400, 300], [CITY.x, 500, 300], [CITY.x, 4300, 300]],
  villages: [{ x: CITY.x - 650, y: CITY.y - 420, n: 7, r: 380 }, { x: CITY.x + 650, y: CITY.y - 420, n: 7, r: 380 }, { x: CITY.x - 650, y: CITY.y + 420, n: 7, r: 380 }, { x: CITY.x + 650, y: CITY.y + 420, n: 7, r: 380 }],
  tents: [{ x: 6500, y: 2400, n: 6, r: 400, col: '#3b5a99', flag: '曹' }],
};
